import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Button, FlexBox } from '@eltoro-ui/components';

import logo from 'assets/Images/logo-update.svg';
import subscribe from 'assets/Images/subscribe.svg';
import resubscribed from 'assets/Images/resubscribe.svg';

import { subscribeUnsubscribe } from 'Requests/Request_Methods/authUserMethods';

import './Unsubscribe.scss';

const Unsubscribe = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const token = searchParams.get('token');
  const [isSubscribed, setIsSubscribed] = useState<'subscribed' | 'unsubscribed' | 'resubscribed'>(
    'subscribed'
  );
  const subscribeRequest = (status: boolean) => {
    if (token) {
      subscribeUnsubscribe(token, { subscribe: status }).then(() => {
        if (status) {
          setIsSubscribed('resubscribed');
        } else {
          setIsSubscribed('unsubscribed');
        }
      });
    }
  };
  const handleSubscribe = (status: boolean) => {
    subscribeRequest(status);
  };

  const subscriptionContent = {
    subscribed: {
      heading: 'Do you want to unsubscribe?',
      description: 'If you unsubscribe you will stop receiving emails from Beewo App.',
      button: true,
      image: subscribe,
      extraContent: null,
    },
    unsubscribed: {
      heading: 'You’re unsubscribed!',
      description: 'We are sorry to see you leave...',
      button: false,
      image: subscribe,
      extraContent: (
        <p className="desc">
          If you unsubscribed by mistake,
          <button className="resbubscribe-btn" onClick={() => handleSubscribe(true)}>
            click here to resubscribe.
          </button>
        </p>
      ),
    },
    resubscribed: {
      heading: 'Excellent choice!',
      description: 'You have subscribed.',
      button: false,
      image: resubscribed,
      extraContent: <p className="desc">You’ll continue receiving emails from Beewo App.</p>,
    },
  };

  const { heading, description, image, button, extraContent } = subscriptionContent[isSubscribed];

  return (
    <FlexBox UNSAFE_className="unsubscribe-wrapper" flexDirection="column">
      <img src={logo} alt="logo" className="logo" />
      <FlexBox
        UNSAFE_className="subscribe-content"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="32px"
      >
        <img src={image} alt={isSubscribed} className="subscribe-letter" />
        <FlexBox flexDirection="column" alignItems="center">
          <h3 className="heading">{heading}</h3>
          <p className="desc">{description}</p>
          {extraContent}
        </FlexBox>
        {button && (
          <Button kind="primary" weight="bold" size="l" onClick={() => handleSubscribe(false)}>
            Unsubscribe
          </Button>
        )}
      </FlexBox>
    </FlexBox>
  );
};

export default Unsubscribe;
